export const getJobs = (state) => state.jobs;
export const getJobTypeFilter = (filters) => filters.type[0];
export const getJobIndustryFilter = (filters) => filters.industry[0];
export const getJobRadiusFilter = (filters) => filters.radius;
export const getKeywordSearchFilter = (filters) => filters.keyword;
export const getSalaryFilter = (filters) => filters.salary;
export const getSelectedFloatButton = (filters) => filters.selectedFloatButton;
